module.exports = __webpack_public_path__ + "img/gift-card-generic-gold.81e910b2.svg";